import React, { useEffect, useMemo, useState } from 'react';
import { createStore, Provider } from 'jotai';
import apptracker from '@src/utils/sensor/apptracker';
import { OPEN_MORE_CHANNELS_DRAWER } from '@src/utils/sensor/track';
import { CURRENT_PRODUCT_MODE } from '@src/utils/constants';
import ServiceIntegrationsDrawer from './ServiceIntegrationsDrawer';

export const OPEN_MORE_CHANNELS_EVENT = 'open-more-channels';

const ServiceIntegrations = () => {
  const [openDrawer, setOpenDrawer] = useState(false);

  const handleCloseDrawer = () => {
    setOpenDrawer(false);
  };

  const store = useMemo(() => {
    return createStore();
  }, []);

  useEffect(() => {
    const handleOpenPage = () => {
      apptracker(OPEN_MORE_CHANNELS_DRAWER, { product: CURRENT_PRODUCT_MODE });
      setOpenDrawer(true);
    };
    window.addEventListener(OPEN_MORE_CHANNELS_EVENT, handleOpenPage);
    return () => {
      window.removeEventListener(OPEN_MORE_CHANNELS_EVENT, handleOpenPage);
    };
  }, []);

  return (
    <div data-ifc-event={OPEN_MORE_CHANNELS_EVENT}>
      <Provider store={store}>
        {openDrawer ? (
          <ServiceIntegrationsDrawer isOpen={openDrawer} closeDrawer={handleCloseDrawer} />
        ) : null}
      </Provider>
    </div>
  );
};

export default ServiceIntegrations;
